module.exports = __webpack_public_path__ + "static/media/test9_3.da8fe1c5.png";